import "bootstrap/dist/css/bootstrap.min.css";
import React, { useCallback, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";

import "react-toastify/dist/ReactToastify.css";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Registeration";
import Unauthorized from "./components/Auth/Unauthorized";
import AdminComponent from "./components/Dashboard/AdminDashboard";
import ModeratorComponent from "./components/Dashboard/ModeratorDashboard";
import UserComponent from "./components/Dashboard/UserDashboard";
import Home from "./components/Home";
import NavBar from "./components/Navigation/TopNav";
import ProfileComponent from "./components/Profile/UserProfile";
import ContactUs from "./components/Contact/ContactUs";
import PrivateRoute from "./services/private-routes";

import { Box } from "@mui/material";
import EventBus from "./common/EventBus";
import { useUser } from "./contexts/UserContext";
import GDPRNotice from "./components/Handlers/GDPRNotice";

const App: React.FC = () => {
  const { user, userRole, userId, handleLogout } = useUser();
  const [moderatorBoard, showModeratorBoard] = useState<boolean>(false);
  const [adminBoard, showAdminBoard] = useState<boolean>(false);
  const drawerWidth = 240;

  const navigate = useNavigate()

  const logOut = useCallback(() => {
    showModeratorBoard(false);
    showAdminBoard(false);
    handleLogout();
    navigate("/login");
  }, [handleLogout, navigate]);

  useEffect(() => {
    if (user && userRole) {
      showModeratorBoard(userRole.includes("moderator"));
      showAdminBoard(userRole.includes("admin"));
    }
    EventBus.on("logout", logOut);
    return () => {
      EventBus.remove("logout", logOut);
    };
  }, [logOut, user, userRole]);

  return (
    <Box
      component="main"
      sx={{
        position: { xs: "relative", sm: userId && "absolute" },
        top: "40px",
        left: { xs: 0, sm: userId && drawerWidth },
      }}
    >
      <GDPRNotice />
      <NavBar
        showModeratorBoard={moderatorBoard}
        showAdminBoard={adminBoard}
        logOut={logOut}
        drawerWidth={drawerWidth}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/profile"
          element={
            <PrivateRoute roles={["user", "moderator", "admin"]}>
              <ProfileComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <PrivateRoute roles={["user", "moderator", "admin"]}>
              <ContactUs />
            </PrivateRoute>
          }
        />
        <Route
          path="/app/*"
          element={
            <PrivateRoute roles={["user", "moderator", "admin"]}>
              <UserComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/mod/*"
          element={
            <PrivateRoute roles={["moderator", "admin"]}>
              <ModeratorComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/*"
          element={
            <PrivateRoute roles={["admin"]}>
              <AdminComponent />
            </PrivateRoute>
          }
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </Box>
  );
};

export default App;
